// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Bl9l","requiredAsterisk":"Info_requiredAsterisk__2ge3O"};